// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { collection, getFirestore } from "firebase/firestore";
import { getDatabase, ref } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBBdnoFfouD4frELk4-6rF2M_V6OW_vMMc",
    authDomain: "pdever-agrimed.firebaseapp.com",
    databaseURL: "https://pdever-agrimed-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "pdever-agrimed",
    storageBucket: "pdever-agrimed.appspot.com",
    messagingSenderId: "1026964881474",
    appId: "1:1026964881474:web:6c24804be9fa158033eddb",
    measurementId: "G-7CEVERQYGB"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const realtimeDb = getDatabase(app);
const auth = getAuth();

const dataCollection = collection(db, "Data");
const logsCollection = collection(db, "Logs");
const porteLogsCollection = collection(db, "PorteLogs");

const chambersRef = ref(realtimeDb, 'chambers');
const accessRef = ref(realtimeDb, 'access');

export {
    dataCollection,
    logsCollection,
    porteLogsCollection,
    chambersRef,
    auth,
    accessRef
};